import React, { useState, useEffect } from "react";
import "./Marks.scss";
import DeleteDialog from "../Dialogs/DeleteDialog";

export default function Marks({
  marks,
  activeMark,
  addMark,
  switchMark,
  deleteMark,
  buildArea
}) {
  return (
    <div className="bookmarks">
      <div className="bookmarks-container">
        {marks.map((_, index) => (
          <BookmarkItem
            key={index}
            index={index}
            isActive={activeMark === index}
            switchMark={switchMark}
            deleteMark={deleteMark}
            buildArea={buildArea}
          />
        ))}
      </div>
      <button onClick={addMark} className="add-mark">
        <span id="button-plus"> + </span>{" "}
        <span id="button-title">Záložka</span>
      </button>
    </div>
  );
}

function BookmarkItem({ index, isActive, switchMark, deleteMark, buildArea }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleRemove = () => {
    if (buildArea.length === 0) {
      deleteMark(index);
    } else {
      setIsDialogOpen(true);
    }
  };

  useEffect(() => {
      const el = document.querySelector('.AkcUiDesigner');
      if (!el)
          return;
      const z_index = parseInt(window.getComputedStyle(el).zIndex) + 10;
      document.documentElement.style.setProperty('--dnd-clone-z', z_index);
  }, [isDialogOpen]);

  return (
    <div className="bookmark">
      <p
        className={`mark-title ${isActive ? "active" : ""}`}
        onClick={() => switchMark(index)}
      >
        {index === 0 ? "Hlavný formulár" : `Záložka ${index}`}
      </p>

      {index !== 0 && (
        <>
          <span
            className={isActive ? "x-button-active" : "x-button"}
            onClick={handleRemove}
          >
            &times;
          </span>

          {isDialogOpen && (
            <DeleteDialog
              setOpen={setIsDialogOpen}
              isOpen={isDialogOpen}
              onConfirm={() => deleteMark(index)}
            />
          )}
        </>
      )}
    </div>
  );
}
